export default __webpack_public_path__ + "static/media/Head_3_Ear_2_C4.10ba0893.svg";